import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NavItemRow = ({
  item = {},
  currentSlug = '',
  onClick,
  className = '',
  iconSize = '1x',
  textClassName = '',
  iconClassName = '',
  withImageSpacing = false,
  label = '',
  icon = null,
  useLongText = true,
  iconStyles
}) => {
  const isActive = item.slug === currentSlug;

  const renderIcon = () => {
    if (icon) {
      return <FontAwesomeIcon size={iconSize} icon={icon} {...(iconStyles ? { style: iconStyles } : {})} />;
    }

    if (item.icon) {
      return <FontAwesomeIcon size={iconSize} icon={item.icon} {...(iconStyles ? { style: iconStyles } : {})} />;
    }

    if (!item.base64Icon) {
      return null;
    }

    const image = (
      <img
        className={`customImgIcon ${isActive ? 'ActivecustomImgIcon' : ''}`}
        src={item.base64Icon}
        alt={item.name || ''}
        {...(iconStyles ? { style: iconStyles } : {})}
      />
    );

    if (!withImageSpacing) {
      return image;
    }

    return <div style={{ position: 'relative', marginRight: isActive ? '20px' : '0px' }}>{image}</div>;
  };

  return (
    <div
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') onClick?.(e);
      }}
      role="button"
      tabIndex={0}
      className={className}
    >
      <div className={iconClassName}>{renderIcon()}</div>
      <div className={textClassName}>{label || (useLongText ? item.longText || item.name : item.name)}</div>
    </div>
  );
};

NavItemRow.propTypes = {
  item: PropTypes.shape({
    base64Icon: PropTypes.string,
    icon: PropTypes.object,
    longText: PropTypes.string,
    name: PropTypes.string,
    slug: PropTypes.string
  }),
  currentSlug: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  iconSize: PropTypes.string,
  textClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  withImageSpacing: PropTypes.bool,
  label: PropTypes.string,
  icon: PropTypes.object,
  useLongText: PropTypes.bool
};

export default NavItemRow;
